/***********************************
    // Menu Style Color
    // black, white, teal, purple
***********************************/
const menuStyle = "black";


/***********************************
    // Menu Type
    // dark, light, colored
***********************************/
const menuType = "dark";



/***********************************
    // Top Bar Style Color
    // black, white, teal, purple
***********************************/
const topbarStyle = "white";


/***********************************
    // Top bar Type
    // dark, light, colored
***********************************/
const topbarType = "light";

/***********************************
    // Navigation Width
    // default, mini
***********************************/
const navWidth = "mini"; // mini

/***********************************
    // Chat Type
    // overlap, squeeze
***********************************/
const chatType = "overlap";

/***********************************
    // Chat Width
    // closed, open
***********************************/
const chatWidth = "closed";


export {
    menuStyle,
    topbarStyle,
    menuType,
    topbarType,
    navWidth,
    chatWidth,
    chatType,
};
